<template>
  <div class="mt-8 filter-wrapper">
    <div class="filter-options">
      <v-form @submit.prevent="addMapping">
        <v-row class="mb-2">
          <v-col cols="6">
            <v-select
              v-model="creator_role"
              :items="allowedCreatorRoles"
              item-text="description"
              item-value="_id"
              label="Vai trò giao việc"
              dense
              outlined
              hide-details
              clearable
              class="required"
              :rules="[$rules.required]"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="receiver_role"
              :items="allowedReceiverRoles"
              item-text="description"
              item-value="_id"
              label="Vai trò nhận việc"
              dense
              outlined
              hide-details
              clearable
              class="required"
              :rules="[$rules.required]"
            />
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn class="text-none text-uppercase" outlined @click="$emit('onClose')">Huỷ</v-btn>
          <v-btn color="primary text-none text-uppercase" elevation="0" type="submit" :loading="isLoading">Lưu</v-btn>
        </v-card-actions>
      </v-form>
    </div>
  </div>
</template>

<script>
// import get from 'lodash-es/get'
// import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

export default {
  components: {},
  data: () => ({
    creator_role: null,
    receiver_role: null,
    isLoading: false,
  }),
  computed: {
    ...mapState('role', ['roles']),
    allowedCreatorRoles() {
      const excluded = ['public', 'authenticated', 'student']
      return this.roles
        .filter(r => !excluded.includes(r.type.toLowerCase()))
        .sort((a, b) => (a.description || '').localeCompare(b.description || ''))
    },

    allowedReceiverRoles() {
      const excluded = ['public', 'authenticated', 'student']
      return this.roles
        .filter(r => !excluded.includes(r.type.toLowerCase()))
        .sort((a, b) => (a.description || '').localeCompare(b.description || ''))
    },
  },
  methods: {
    async addMapping() {
      try {
        if (!this.creator_role || !this.receiver_role) {
          this.$alert.error('Thiếu vai trò')
          return
        }
        this.isLoading = true
        const params = {
          creator_role: this.creator_role,
          receiver_role: this.receiver_role,
        }
        console.log(params)
        const res = await this.$store.dispatch('configtaskroles/setConfigTaskRoles', params)
        if (res) {
          this.creator_role = null
          this.receiver_role = null
          this.$emit('onClose')
          this.$alert.success('Thêm mới cài đặt quyền thành công')
        }
      } catch (err) {
        console.log('err', err)
      } finally {
        this.isLoading = false
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('role/fetchRoles')
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
